<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        @for (it of breadcrumbs; track it.path) {
        <li class="breadcrumb-item"> <a [routerLink]="[it.path]" [queryParams]="it.params">{{it.label}}</a></li>
        }
    </ol>
</nav>